import { Col, ConfigProvider, Grid } from "antd";
import React, { useCallback, useState } from "react";
import { createUseStyles } from "react-jss";
import { MetaContextProvider } from "../core/contexts/MetaContextProvider";
import { NotificationContextProvider } from "../core/contexts/NotificationContextProvider";
import { PricingContextProvider } from "../core/contexts/PricingContextProvider";
import { _THEME } from "../theme";
import Footer from "./footer";
import Navbar from "./navBar";
import { _STYLES } from "./utils/customStyles";

const { useBreakpoint } = Grid;

const { bodyWrap, bodyInnerWrap } = _STYLES;
const useStyles = createUseStyles({
  bodyWrap,
  bodyInnerWrap,
});

const Layout = (props) => {
  const [scrolled, setScrolled] = useState(false);

  const handleScroll = (el) => {
    setScrolled(el.target.scrollTop > 24);
  };

  const screens = useBreakpoint();

  const classes = useStyles();
  //globalStyle();

  const getResponsiveFontSize = useCallback(() => {
    if (screens.lg) {
      return 14;
    }
    if (screens.md || screens.sm) {
      return 14;
    }
    if (screens.xs) {
      return 12;
    }

    return 14;
  }, [screens.lg, screens.md, screens.sm, screens.xs]);

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: _THEME.color.primary.main,
          colorBgContainerDisabled: _THEME.color.white,
          colorTextDisabled: _THEME.color.grey.accent4,
        },
        components: {
          Button: {
            colorLink: _THEME.color.primary.main,
            fontSizeLG: getResponsiveFontSize(),
            fontSize: getResponsiveFontSize(),
            fontSizeSM: getResponsiveFontSize(),
            fontSizeXL: getResponsiveFontSize(),
          },
          Typography: {
            colorPrimary: _THEME.color.text.main,
          },
          Table: {
            headerBorderRadius: 16,
            //borderColor: mainColor3,
            cellFontSize: _THEME.size.sm[3],
            fontSizeLG: getResponsiveFontSize(),
            fontSize: getResponsiveFontSize(),
            fontSizeSM: getResponsiveFontSize(),
            fontSizeXL: getResponsiveFontSize(),
          },
          Segmented: {
            itemSelectedBg: _THEME.color.primary.main,
            itemSelectedColor: _THEME.color.white,
            //trackBg: _THEME.color.grey.accent6,
            itemColor: _THEME.color.text.main,
            fontSizeLG: getResponsiveFontSize(),
            fontSize: getResponsiveFontSize(),
            fontSizeSM: getResponsiveFontSize(),
            fontSizeXL: getResponsiveFontSize(),
          },
          Form: {
            labelFontSize: getResponsiveFontSize(),
            itemMarginBottom: screens.lg ? 32 : 16,
          },
          Input: {
            inputFontSize: getResponsiveFontSize(),
            inputFontSizeLG: getResponsiveFontSize(),
            inputFontSizeSM: getResponsiveFontSize(),
            fontSizeLG: getResponsiveFontSize(),
            fontSize: getResponsiveFontSize(),
            fontSizeSM: getResponsiveFontSize(),
            fontSizeXL: getResponsiveFontSize(),
            fontSizeIcon: getResponsiveFontSize(),
          },
          Select: {
            fontSizeLG: getResponsiveFontSize(),
            fontSize: getResponsiveFontSize(),
            fontSizeSM: getResponsiveFontSize(),
            fontSizeXL: getResponsiveFontSize(),
          },
          Dropdown: {
            fontSizeLG: getResponsiveFontSize(),
            fontSize: getResponsiveFontSize(),
            fontSizeSM: getResponsiveFontSize(),
            fontSizeXL: getResponsiveFontSize(),
          },
          Tabs: {
            fontSizeLG: getResponsiveFontSize(),
            fontSize: getResponsiveFontSize(),
            fontSizeSM: getResponsiveFontSize(),
            fontSizeXL: getResponsiveFontSize(),
          },
          DatePicker: {
            fontSizeLG: getResponsiveFontSize(),
            fontSize: getResponsiveFontSize(),
            fontSizeSM: getResponsiveFontSize(),
            fontSizeXL: getResponsiveFontSize(),
          },
        },
      }}
    >
      <MetaContextProvider>
        <PricingContextProvider>
          <NotificationContextProvider>
            <Navbar scrolled={scrolled} />
            <Col
              className={classes.bodyWrap}
              id="bodyWrap"
              onScroll={handleScroll}
            >
              <Col className={classes.bodyInnerWrap}>{props.children}</Col>
              <Footer />
            </Col>
          </NotificationContextProvider>
        </PricingContextProvider>
      </MetaContextProvider>
    </ConfigProvider>
  );
};

export default Layout;
